<div
    class="flex flex-row gap-14 grow flex-wrap justify-center invoice-payment-options"
>
    <p-button
        label="Πίστωση"
        [severity]="'danger'"
        raised
        [style]="{ width: '150px', height: '130px' }"
        (onClick)="option(5)"
        class="invoice-payment-button"
    />
    <p-button
        label="Μετρητά"
        [severity]="'success'"
        raised
        [style]="{ width: '150px', height: '130px' }"
        (onClick)="option(3)"
        class="invoice-payment-button"
    />
    <p-button
        label="I.R.I.S"
        [severity]="'info'"
        raised
        [style]="{ width: '150px', height: '130px' }"
        (onClick)="option(8)"
        class="invoice-payment-button"
    />
    <p-button
        raised
        [style]="{ width: '150px', height: '130px' }"
        label="Τραπεζική Κάρτα"
        (onClick)="option(7)"
        class="invoice-payment-button"
    />

    <p-button
        raised
        [severity]="'help'"
        [style]="{ width: '150px', height: '130px' }"
        label="Επαγ. Λογαριασμός Πληρωμών Ημεδαπής"
        (onClick)="option(1)"
        class="invoice-payment-button"
    />

    <!-- <div
        class="flex payment-option center option-credit grow shadow-md shadow-xl justify-center"
        (click)="option(5)"
    >
        <label>Πίστωση</label>
    </div>
    <div
        class="flex payment-option center option-cash grow shadow-xl justify-center"
        (click)="option(3)"
    >
        <label>Μετρητα</label>
    </div>
    <div
        class="flexx payment-option center option-iris grow shadow-xl justify-center"
        (click)="option(8)"
    >
        <label>I.R.I.S</label>
    </div>
    <div
        class="flex payment-option center option-pos grow shadow-xl justify-center"
        (click)="option(7)"
    >
        <label>Τραπεζική Κάρτα</label>
    </div> -->
</div>

<!-- Κωδικός Περιγραφή
1 Επαγ. Λογαριασμός Πληρωμών Ημεδαπής
2 Επαγ. Λογαριασμός Πληρωμών Αλλοδαπής
3 Μετρητά
4 Επιταγή
5 Επί Πιστώσει
6 Web Banking
7 POS / e-POS
8 Άμεσες Πληρωμές IRIS -->
